import { useMsal } from '@azure/msal-react';
import WizardForm from '../../../components/forms/WizardForm';
import { WizardFormProps } from '../../../components/forms/WizardForm/types';
import WizardStep from '../../../components/forms/WizardForm/WizardStep';
import addBranchProps from './addBranchProps';
import useHtmlTitle from '../../../components/Utilities/useHtmlTitle';
import useBodyClass from '../../../components/Utilities/useBodyClass';
import { FormStepStatus, FormStepStatusDto } from '../../../api/web-api-client';
import useAccountContext from '../../../authentication/hooks';
import OrganisationDetails from '../organisationDetails';

const addBranchWizardProps: WizardFormProps = {
    locationOnCompletion: '/',
    lastStepNextButtonTitle: 'Save and close',
    // nextButtonTitle: 'Save and next',
    canSaveDraft: false,
    confirmationOnSubmission: {
        modalTitle: 'Add branch or location confirmation',
        modalBodyText: 'Are you sure you want to add this branch/location?',
        yesButtonTitle: 'Yes, submit',
        noButtonTitle: 'No, cancel',
    },
};

const statuses: FormStepStatusDto[] = [{ status: FormStepStatus.NotStarted }];

const AddBranch = () => {
    const { accounts, instance } = useMsal();
    const account = useAccountContext();
    useHtmlTitle('Add branch or location | NMI Services portal');
    useBodyClass('wizard');
    return (
        <WizardForm {...addBranchWizardProps}>
            <WizardStep {...addBranchProps(accounts, instance, statuses, account)}>
                <OrganisationDetails />
            </WizardStep>
        </WizardForm>
    );
};

export default AddBranch;
